import { reactive } from 'vue';

export const accountSettingsUsersState = reactive<{
  roles: string[];
  organizations: Record<string, unknown>[];
}>({
  roles: [],
  organizations: [],
});
